// ThreeG TMS specific constants

export const MOHAWK_PROD_TMSID = 4126;

export const ALL_THREEG_MODES = [
  'TL',
  'LTL',
  'Drayage',
  'Ocean',
  'Air',
  'Rail',
  'Parcel',
  'Intermodal',
] as const;

export const MOHAWK_PROD_MODES = ['LTL', 'TL', 'Parcel'] as const;

export enum AvailableTabs {
  customer = 'customer',
  billTo = 'billTo',
  specifications = 'specifications',
  items = 'items',
  accessorials = 'accessorials',
  pickup = 'pickup',
  consignee = 'consignee',
  carrier = 'carrier',
  operator = 'operator',
  rates = 'rates',
  documents = 'documents',
}

// Values are Mohawk's exact 3G Message Type Names. Labels are the readable dropdown text.
export enum ThreeGDocumentMessageType {
  POD = 'POD',
  BOL = 'BOL',
  RateConfirmation = 'RateConfirmation',
  DeliveryReceipt = 'DeliveryReceipt',
  LumperReceipt = 'LumperReceipt',
  Other = 'Other',
}

export const THREEG_DOCUMENT_MESSAGE_TYPE_OPTIONS: {
  value: ThreeGDocumentMessageType;
  label: string;
}[] = [
  { value: ThreeGDocumentMessageType.POD, label: 'POD' },
  { value: ThreeGDocumentMessageType.BOL, label: 'BOL' },
  {
    value: ThreeGDocumentMessageType.RateConfirmation,
    label: 'Rate Confirmation',
  },
  {
    value: ThreeGDocumentMessageType.DeliveryReceipt,
    label: 'Delivery Receipt',
  },
  { value: ThreeGDocumentMessageType.LumperReceipt, label: 'Lumper Receipt' },
  { value: ThreeGDocumentMessageType.Other, label: 'Other' },
];

export const weightUnitsList: string[] = ['lbs', 'kg'];

export const FORM_RESET_OPTIONS = {
  keepDefaultValues: false,
  keepTouched: false,
  keepDirtyValues: false,
  keepDirty: false,
};

export const FIELD_PREFIX_MAP: Record<string, string> = {
  customer: 'Customer',
  billTo: 'Bill To',
  pickup: 'Pickup',
  consignee: 'Consignee',
  specifications: 'Specs',
  accessorials: 'Accessorials',
  rateData: 'Rates',
  documents: 'Documents',
};

export const FIELD_NAME_REPLACEMENTS: Record<string, string> = {
  externalTMSID: 'Name',
  refNumber: 'Ref #',
  poNums: 'PO #',
  zipCode: 'Zip Code',
  readyTime: 'Pickup Date',
  mustDeliver: 'Delivery Date',
  apptStartTime: 'Appointment Start Time',
  apptEndTime: 'Appointment End Time',
  apptType: 'Appointment Type',
  unit: 'Units',
};
